import BlockOutDateList from "./pages/ListPage.vue";
import BlockOutDateDetail from "./pages/FormPage.vue";
import BlockOutDateIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/block_out_date",
    component: BlockOutDateIndex,
    redirect: "/block_out_date/list",
    name: "block_out_date",
    children: [
      {
        path: "list",
        component: BlockOutDateList,
        name: "block_out_date.list",
      },
      {
        path: "create",
        component: BlockOutDateDetail,
        name: "block_out_date.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: BlockOutDateDetail,
        name: "block_out_date.edit",
        props: { create: false },
      },
    ],
  },
];
